import React from 'react';
import ReportContext from './ReportContext';
import { DrawerStyles } from './Style'
import { Title as ScreenTitle } from 'components'
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { SmallSpace, Space } from 'styles/GlobalStyle';
import { useSelector } from 'react-redux';
import AssessmentDetails from '../Assessment/AssessmentDetails';
import ReportHeader from './ReportHeader';

const ReportDrawer = (props) => {
    const { open, handleClose } = props
    const { assessment } = useSelector(state => state.assessment)
    const { battery_label, reading_assessment_name } = assessment || {}

    return (
        <DrawerStyles anchor={"bottom"} open={open} onClose={handleClose}>
            <div className='drawer-header'>
                <div className='report-header'>
                    <ReportHeader {...props} batteryAction={handleClose}/>
                    {/* <ScreenTitle {...props} breadcrumbs={true}>
                        <div className='bread-crumbs-title'>
                            {battery_label &&
                                <div className='battery_name' onClick={handleClose}>
                                    {"סוללת "}
                                    {assessment?.battery_label}
                                    <div>{">"}</div>
                                </div>}
                            {"דוח אישי"}
                        </div>
                    </ScreenTitle> */}
                    {/* <SmallSpace /> */}
                    {/* <AssessmentDetails /> */}
                </div>
                <div>
                    <IconButton onClick={handleClose}>
                        <Close />
                    </IconButton>
                </div>
            </div>
            <Space />
            <ReportContext hideHeader {...props} />
        </DrawerStyles>
    );
}

export default ReportDrawer